import { useQuery } from "@tanstack/react-query";
import { AuditDashboardReceiptsByDateModel } from "models";
import { getAuditDashboardReceiptsByDate } from "services/auditService";

export function useAuditDashboardReceiptsByDate(
  storeId: string | null | undefined,
  reportDate: string | null | undefined,
  enabled = true
) {
  return useQuery<AuditDashboardReceiptsByDateModel, Error>({
    queryKey: ["audit-dashboard-receipts-by-date", storeId, reportDate],
    queryFn: async () => {
      const response = await getAuditDashboardReceiptsByDate(storeId!, reportDate!);
      return response
        ? AuditDashboardReceiptsByDateModel.fromServerData(response)
        : AuditDashboardReceiptsByDateModel.createEmpty();
    },
    enabled: Boolean(enabled && storeId && reportDate),
    retry: false,
  });
}
